import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import axios from "axios"
import * as endpoint from "../../booking/constants/Endpoints"
import { hosts } from "./itinerary-module"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { trackTravelPlannerInteraction } from "../../helpers/tracking"

export class ItineraryPassport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      gate: props.gate,
      waitingTime: undefined,
      airlinesPageLink: props.airlinesPageLink,
      hidePastSteps: props.hidePastSteps,
      isDeparture: props.flightInfo.Direction === "D",
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
    this.handleClickTracking = this.props.handleClickTracking.bind(this)
  }

  componentDidMount() {
    if (!this.props.currentPageJson.hidePassportWaitingTime) {
      this.getWaitingTime(this.state.gate && this.state.gate.gateId)
    }
  }

  getWaitingTime(gateId) {
    if (gateId && this.state.isDeparture) {
      axios.get(endpoint.WAITING_TIME_PASSPORT(hosts, "paskontrol" + gateId.charAt(0))).then(
        (result) => {
          if (result.status !== 204) {
            this.setState({
              waitingTime: result.data.waitingTimeInterval + " min",
            })
          }
        },
        (error) => {
          this.setState({
            waitingTime: undefined,
            error,
          })
        },
      )
    } else {
      this.setState({
        waitingTime: undefined,
      })
    }
  }

  handleAccordionClick = (e) => {
    this.showHideContent(e, ".contentWrapper")
    this.handleAccordionTracking()
  }

  handleAccordionTracking = () => {
    this.setState({ accordionOpen: !this.state.accordionOpen }, () => {
      if (this.state.accordionOpen) {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_open", { fold_title: this.props.block.heading })
      } else {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_close", { fold_title: this.props.block.heading })
      }
    })
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const infoboxTheme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.securityBackgroundColor)
    const hasContentBlocksBeforeText = this.props.block.contentAreaBeforeText?.length > 0
    const hasAccodionContentBlocks = this.props.block.contentArea?.length > 0
    const newLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    return (
      <div
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem ${theme ? theme : ""} foldable`}
      >
        <div className={"departure-info__essentials__detailitems__detailitem__header pointer"} onClick={(e) => this.handleAccordionClick(e)}>
          <h5>{this.props.block.heading}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading}</h6> : ""}
          {this.state.isDeparture && !this.props.currentPageJson.hidePassportWaitingTime ? (
            <div className="floatbox">
              <div>{this.state.waitingTime ? `${this.state.waitingTime}` : `${this.props.awaitingLabel}`}</div>
            </div>
          ) : null}
        </div>
        <div className={"contentWrapper show-hide"}>
          {hasContentBlocksBeforeText ? this.renderContentBlocks(this.props.block.contentAreaBeforeText) : ""}
          {this.state.waitingTime && this.state.isDeparture && !this.props.currentPageJson.hidePassportWaitingTime ? (
            <div className={`departure-info__essentials__detailitems__detailitem__infobox ${infoboxTheme}`}>
              <div className="grid">
                <div className="grid-item col--12 col-sm--12">
                  <div className="info-text">
                    {this.props.block.waitingTimeLabel} <span>{this.props.block.expectedLabel}</span>
                  </div>
                  <h5>{this.state.waitingTime}</h5>
                </div>
              </div>
            </div>
          ) : this.props.block.text || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {this.props.block.text ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={this.props.block.linkToAirlineBool ? newLink : this.props.block.buttonLink}
                    onClick={() => this.handleClickTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {hasAccodionContentBlocks ? this.renderContentBlocks(this.props.block.contentArea) : ""}
        </div>
      </div>
    )
  }
}
